/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Title_PlaceholderInputs */

const en_settings_tickets_title_placeholder = /** @type {(inputs: Settings_Tickets_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief summary of your issue`)
};

const zh_settings_tickets_title_placeholder = /** @type {(inputs: Settings_Tickets_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简要描述你的问题`)
};

/**
* | output |
* | --- |
* | "Brief summary of your issue" |
*
* @param {Settings_Tickets_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_title_placeholder = /** @type {((inputs?: Settings_Tickets_Title_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Title_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_title_placeholder(inputs)
	return zh_settings_tickets_title_placeholder(inputs)
});
export { settings_tickets_title_placeholder as "settings.tickets.title_placeholder" }